import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import {
  setGroupIndex,
  setCourseIndex,
  toggleGroupOrder,
  reorderItems,
  saveGroupOrder,
} from 'store/Group/actions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { Button, Card, Row } from 'reactstrap'
import { useSelector } from 'react-redux'

const ReorderItems = (props) => {
  const dispatch = useDispatch()
  const { coursesState, groups, user } = props

  const reorderRef = useRef()

  useEffect(() => {
    const handleReorderClick = (e) => {
      const isReorderButton = e.target.closest('.reorder-button')

      if (
        reorderRef.current &&
        props.groups.groupOrderShowing &&
        !reorderRef.current.contains(e.target) &&
        !isReorderButton
      ) {
        dispatch(toggleGroupOrder())
      }
    }

    document.addEventListener('click', handleReorderClick, true)

    return () => {
      document.removeEventListener('click', handleReorderClick, true)
    }
  }, [props.groups.groupOrderShowing, dispatch])

  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}
  return (
    <Card
      innerRef={reorderRef}
      className='position-absolute reorder-items-wrapper'
      style={{ zIndex: '111111', height: '435px' }}
    >
      <div className='scrollbar reorder-items-list'>
        {groups.learningPlanGroups
          .filter(
            (item) =>
              item.type === 'course' && (user.access === 1 || item.owner === 1)
          )
          .map((group, index) => {
            return (
              <div key={group.id}>
                {(() => {
                  const groupCourses = (
                    groups.groupsCourses[group.id] || []
                  ).map((item) => item.course_id)

                  let courses = []
                  groupCourses.map(
                    (id) =>
                      (courses = [
                        ...courses,
                        ...coursesState.progress.filter(
                          (course) => course.id === id
                        ),
                      ])
                  )
                  return (
                    <div>
                      <div
                        onClick={() => dispatch(setGroupIndex(index))}
                        className={`category-name-wrapper${
                          groups.groupIndex === index &&
                          groups.courseIndex === null
                            ? ' selected'
                            : ''
                        }`}
                      >
                        <h2 className='category-name'>{group.name}</h2>
                      </div>
                      <ul
                        className='list-unstyled mb-0'
                        style={{
                          display: groups.groupIndex === index ? '' : 'none',
                        }}
                      >
                        {courses.map((item, index) => (
                          <li
                            key={item.id}
                            onClick={() => dispatch(setCourseIndex(index))}
                            className={
                              groups.courseIndex === index ? 'selected' : ''
                            }
                          >
                            {item.name}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )
                })()}
              </div>
            )
          })}
      </div>
      {(() => {
        switch (true) {
          case groups.courseIndex === null:
            return (
              <>
                <Row className='justify-content-center pb-3'>
                  {console.log('groups.groupIndex', groups.groupIndex)}
                  <button
                    onClick={() =>
                      groups.groupIndex > 0
                        ? dispatch(reorderItems(groups.groupIndex - 1))
                        : null
                    }
                    title='Bring item up'
                    style={{ padding: '2px 10px' }}
                    className='btn btn-transparent border'
                  >
                    <FontAwesomeIcon
                      className='cursor-pointer font-weight-bolder text-center'
                      icon={faArrowUp}
                      // onClick={close}
                    />
                  </button>
                  <button
                    onClick={() =>
                      groups.groupIndex < groups.learningPlanGroups.length - 1
                        ? dispatch(reorderItems(groups.groupIndex + 1))
                        : null
                    }
                    style={{ padding: '2px 10px' }}
                    title='Bring item down'
                    className='btn btn-transparent border'
                  >
                    <FontAwesomeIcon
                      className='cursor-pointer font-weight-bolder text-center'
                      icon={faArrowDown}
                    />
                  </button>
                </Row>
                <hr className='m-0' />
              </>
            )
          case groups.groupIndex === null:
            let _groupCourses = []

            Object.keys(groups.groupsCourses).map(
              (groupId) =>
                (_groupCourses = [
                  ..._groupCourses,
                  ...groups.groupsCourses[groupId].map(
                    (item) => item.course_id
                  ),
                ])
            )

            return (
              <>
                <Row className='justify-content-center pb-3'>
                  <button
                    onClick={() =>
                      groups.courseIndex > 0
                        ? dispatch(reorderItems(groups.courseIndex - 1))
                        : null
                    }
                    style={{ padding: '2px 10px' }}
                    title='Bring item up'
                    className='btn btn-default course-reorder-btn reorder-btn-up'
                  >
                    <FontAwesomeIcon
                      className='cursor-pointer font-weight-bolder text-center'
                      icon={faArrowUp}
                    />
                  </button>
                  <button
                    onClick={() =>
                      groups.courseIndex < groups.individualCourses.length - 1
                        ? dispatch(reorderItems(groups.courseIndex + 1))
                        : null
                    }
                    style={{ padding: '2px 10px' }}
                    title='Bring item down'
                    className='btn btn-default course-reorder-btn reorder-btn-down'
                  >
                    <FontAwesomeIcon
                      className='cursor-pointer font-weight-bolder text-center'
                      icon={faArrowDown}
                    />
                  </button>
                </Row>
                <hr />
              </>
            )
          default:
            const groupId = groups.learningPlanGroups[groups.groupIndex].id
            const groupCourses = (groups.groupsCourses[groupId] || []).map(
              (item) => item.course_id
            )

            return (
              <>
                <Row className='justify-content-center pb-3'>
                  <button
                    onClick={() =>
                      groups.courseIndex > 0
                        ? dispatch(reorderItems(groups.courseIndex - 1))
                        : null
                    }
                    style={{ padding: '2px 10px' }}
                    title='Bring item up'
                    className='btn btn-info'
                  >
                    <FontAwesomeIcon
                      className='cursor-pointer font-weight-bolder text-center'
                      icon={faArrowUp}
                    />
                  </button>
                  <button
                    onClick={() =>
                      groups.courseIndex < groupCourses.length - 1
                        ? dispatch(reorderItems(groups.courseIndex + 1))
                        : null
                    }
                    style={{ padding: '2px 10px' }}
                    title='Bring item down'
                    className='btn btn-info'
                  >
                    <FontAwesomeIcon
                      className='cursor-pointer font-weight-bolder text-center'
                      icon={faArrowDown}
                    />
                  </button>
                </Row>
                <hr className='m-0' />
              </>
            )
        }
      })()}
      <div style={{ textAlign: 'left' }} className='pt-2 '>
        <Button
          onClick={() => dispatch(saveGroupOrder())}
          className='btn btn-info mr-2'
          size='sm'
        >
          {language.general ? language.general.save : null}
        </Button>
        <button
          onClick={() => dispatch(toggleGroupOrder())}
          className='btn text-info bg-transparent border-0'
          size='sm'
          style={{ padding: '4px 8px', fontSize: '12px' }}
        >
          {language.general ? language.general.cancel : null}
        </button>
      </div>
    </Card>
  )
}

export default ReorderItems
